import { AxiosPromise } from 'axios';
import { urlHelper } from 'src/app/helpers';
import { axios } from 'src/app/utils';
import { urlsConfig } from 'src/configs';
import { queryTypes, serviceProjectTypes } from 'src/types';
import { ProjectDeleteResultType } from 'src/types/services/ppm/project-service.type';

export const createProject = (
  projectCreateData: serviceProjectTypes.ProjectCreateDataType,

  options: { blockErrorHandler: boolean },
): AxiosPromise<serviceProjectTypes.ProjectCreateResultType> => {
  return axios.post(urlsConfig.project.createProject, projectCreateData);
};

export const lookupProject = ({
  limit,
  offset,
  ids,
  value,
  order,
  sortOrder,
  blockSpinner,
  load,
  search,
}: serviceProjectTypes.ProjectLookupDataType): AxiosPromise<serviceProjectTypes.ProjectLookupResultType> => {
  const query: queryTypes.LookupQueryParametersType = {};

  if (ids) {
    query.ids = ids.join(',');
  }
  if (search) {
    query.search = search.join(',');
  }
  if (value) {
    query.search = value;
  }

  if (order && sortOrder) {
    query.order = order;
    query.sortOrder = sortOrder;
  }

  if (limit && offset) {
    query.limit = limit;
    query.offset = offset;
  }

  return axios.get(urlsConfig.project.lookupProject, {
    blockSpinner,
  });
};

export const lookupProjectWithEvent = ({
  limit,
  offset,
  ids,
  eventIds,
  value,
  order,
  sortOrder,
  blockSpinner,
  load,
  search,
}: serviceProjectTypes.ProjectLookupDataType): AxiosPromise<serviceProjectTypes.ProjectLookupResultType> => {
  const query: queryTypes.LookupQueryParametersType = {};

  if (ids) {
    query.ids = ids.join(',');
  }
  if (search) {
    query.search = search.join(',');
  }
  if (value) {
    query.search = value;
  }
  if (eventIds) {
    return axios.get(`${urlsConfig.project.lookupProject}?eventIds=${eventIds}`, {
      blockErrorHandler: true,
    });
  }

  if (order && sortOrder) {
    query.order = order;
    query.sortOrder = sortOrder;
  }

  return axios.get(urlHelper.addQueryParameters(query, urlsConfig.project.lookupProject), {
    blockSpinner,
  });
};

export const editProject = (
  projectEditData: serviceProjectTypes.ProjectEditDataType,
  options: { blockErrorHandler: boolean },
): AxiosPromise<serviceProjectTypes.ProjectCreateResultType> => {
  return axios.patch(urlsConfig.project.projectEdit, projectEditData);
};

export const deleteProject = (
  projectId: string,
  options: { blockErrorHandler: boolean },
): AxiosPromise<ProjectDeleteResultType> => {
  return axios.delete(`${urlsConfig.project.projectDelete}/${projectId}`);
};
